export const convertDatetimeToEpochtime = datetime =>
  new Date(datetime).getTime()

const convertDatetimesToEpochtimes = datetimes => {
  const epochtimes = datetimes.map(datetime =>
    convertDatetimeToEpochtime(datetime)
  )

  return epochtimes
}

export default convertDatetimesToEpochtimes



// WEBPACK FOOTER //
// ./src/utility/convertDatetimesToEpochtimes.js